import styled, { css } from 'styled-components';

import { CheckboxWrapper } from '../../Form/Checkbox/styled';

export const StyledFilterContent = styled.div(
  ({ theme: { colors, admanColors } }) => css`
    position: absolute;
    border-radius: 8px;
    background: ${colors!.colorWhite};
    border: 1px solid ${admanColors!.gray.light.bg3[2]};
    box-shadow: 0 0 32px -8px rgb(23 29 35 / 25%);
    font-size: 14px;
  `
);
export const StyledCheckboxWrapper = styled(CheckboxWrapper)(
  ({ theme: { admanColors, spacers } }) => css`
    padding: ${spacers!.spacer02} ${spacers!.spacer03};
    width: 120px;
    height: 35px;

    :hover {
      background: ${admanColors!.blue.dark.bg1[1]};
      border-radius: 8px;
    }
  `
);

export const StyledSelectAll = styled.div(
  ({ theme: { admanColors, spacers } }) => css`
    font-family: InspireTWDC;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    margin: ${spacers!.spacer04} ${spacers!.spacer04} ${spacers!.spacer02} ${spacers!.spacer04};
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: ${admanColors!.blue.dark.bg1[0]};

    :hover {
      cursor: pointer;
    }
  `
);
